import React from "react";
import moment from "moment";
import { CalendarClock, Clock3, Monitor, ShieldCheck } from "lucide-react";

import { Card, CardContent, CardHeader } from "../../../../components/ui/card";
import { Badge } from "../../../../components/ui/badge";

const formatDate = (value) => {
  if (!value) return "N/A";
  const date = moment(value);
  return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "N/A";
};

const getOsBadgeClassName = (operatingSystem = "") => {
  const normalized = operatingSystem.toLowerCase();
  if (normalized.includes("windows")) {
    return "bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20";
  }
  if (normalized.includes("linux")) {
    return "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20";
  }
  return "bg-muted text-muted-foreground";
};

const DeviceDetail = ({ label, value, icon: Icon }) => (
  <div className="flex items-start gap-3 rounded-xl border border-border/40 bg-muted/20 px-3 py-2.5">
    <Icon className="w-4 h-4 text-muted-foreground mt-0.5 flex-shrink-0" />
    <div className="min-w-0">
      <div className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </div>
      <div className="text-sm font-medium text-foreground break-words">{value || "N/A"}</div>
    </div>
  </div>
);

const AzureDeviceItem = ({ device }) => {
  const displayName = device.displayName || "Unnamed device";
  const operatingSystem = device.operatingSystem || "Unknown";

  return (
    <Card className="cloud-list-card rounded-2xl transition-all flex flex-col h-full">
      <CardHeader className="pb-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3 min-w-0">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Monitor className="w-6 h-6 text-primary" />
            </div>
            <div className="min-w-0 pt-1">
              <h3 className="font-semibold text-sm text-foreground break-words" title={displayName}>
                {displayName}
              </h3>
              <p className="text-xs text-muted-foreground mt-1">
                Azure registered device
              </p>
            </div>
          </div>
          <Badge variant="secondary" className={`text-xs rounded-md ${getOsBadgeClassName(operatingSystem)}`}>
            {operatingSystem}
          </Badge>
        </div>
      </CardHeader>

      <CardContent className="flex flex-col flex-1 gap-3">
        <DeviceDetail
          icon={ShieldCheck}
          label="OS Version"
          value={device.operatingSystemVersion}
        />
        <DeviceDetail
          icon={CalendarClock}
          label="Registration Time"
          value={formatDate(device.azureRegistrationDateTime)}
        />
        <DeviceDetail
          icon={Clock3}
          label="Synced At"
          value={formatDate(device.syncedAt)}
        />
      </CardContent>
    </Card>
  );
};

export default AzureDeviceItem;
